<template>
    <div class="academy">
        
            <div class=" color-blanco" :style="'background-image: url(https://nncms.actstudio.xyz/'+academy.cover.path+')' " style="background-size: cover; background-position: 25% 25%;  height:calc((100vh - 110px) / 2);">
                <div style="background: #5c27b2a6; position: relative; height:calc((100vh - 110px) / 2);" >   
                    <v-container>
                        <v-row class="py-10" justify="center" style="height:calc((100vh - 110px) / 2);" align="center" >
                            <v-col class="text-center" cols="12">
                                <span class="montserrat bold enfasis-size">{{academy.titulo}}</span>
                                <span class="d-block mb-5 single-item-size">{{academy.subtitulo}} </span>
                                
                                
                            </v-col>
                            
                        </v-row>
                        
                    </v-container>
                </div>
            </div>

            <v-container>
                <v-row justify="center" class="py-3">
                    <v-col cols="12" sm="8" md="8">
                        <span class="single-item-size color-morado-2" v-html="academy.descripcion" ></span>
                    </v-col>
                </v-row>
            </v-container>

            <v-container >
                <v-row class="py-5 px-4">
                    <v-col  cols="12" sm="4"  v-for="(cards, card) in academy.tarjetas" :key="'cards-'+card" > 
                        <v-card color="#48306E" height="250 " elevation="0">
                            <v-card-text  class="pa-sm-10  color-blanco" >
                                <span class="d-block mb-4 titulos-size bold">{{cards.value.titulo}}</span>
                                <span class="d-block single-item-size">{{cards.value.descripcion}} </span>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    
                </v-row>
            </v-container>

            <v-container>
                <v-row justify="start">
                    <v-col cols="12" sm="6" align-self="center" class="px-5 px-sm-16">
                        <span class="d-block titulos-size bold mb-6 color-morado-2">Neutral Networks Academy</span>
                        <span class="single-item-size color-morado-2" v-html="academy.descripcionAcademy" ></span>
                        

                    </v-col>
                    <v-col cols="12" sm="6"  class="align-items-start align-center text-center">
                        <v-img :src="'https://nncms.actstudio.xyz/'+academy.imagenAcademy.path" width="100%" height="80%"></v-img>

                    </v-col>
                    
                </v-row>
            </v-container>
        
        
    </div>
</template>
<script>
export default {
    data() {
        return{
            academy:[],
        }
    },
    mounted: function(){
        fetch('http://nncms.actstudio.xyz/api/singletons/get/Academy?token=8cf7ca41761951fdde0c1e2cfda401')
        .then(data => data.json())
        .then(data => this.academy = data);
    },
    
}
</script>